<template>
  <q-header class="giscube-header">
    <q-toolbar class="giscube-toolbar">
      <a v-if="panoramaHeader ? $q.screen.gt.md : true" class="giscube-header-brand cursor-pointer" :href="brandLink"><img :src="brandLogo"><span v-html="brandText"></span></a>
      <q-separator v-if="$q.screen.gt.md" vertical />
      <span v-if="panoramaHeader">
        <panorama-campaigns-dropdown :style="!$q.screen.gt.md && 'margin-left: 6px'" :isHeader="true" :isMenu="false" class="q-mx-sm" />
        <q-tooltip>
          Històric de campanyes
        </q-tooltip>
      </span>
      <q-separator vertical v-if="!isMenu && panoramaHeader" />
      <q-btn
        flat dense
        v-if="isMenu && panoramaHeader"
        icon="drag_indicator"
      >
        <q-menu>
          <panorama-tools :isHeader="true"/>
        </q-menu>
      </q-btn>
      <panorama-tools v-else-if="panoramaHeader" :isHeader="true"/>
      <panorama-show-lateral-button />
      <q-space/>
      <slot name="auth-header-item">
        <auth-header-item :isPanoramaHeader="panoramaHeader"/>
      </slot>
      <span v-if="panoramaHeader">
        <panorama-options-dropdown :isHeader="true" :isMenu="isMenu"/>
        <q-tooltip content-style="width: 132px!important">
          Opcions Mapia STREETS
        </q-tooltip>
      </span>
    </q-toolbar>

  </q-header>
</template>

<script>
import AuthHeaderItem from 'components/Header/AuthHeaderItem.vue'
import PanoramaCampaignsDropdown from 'components/Panorama/PanoramaCampaignsDropdown.vue'
import PanoramaTools from 'components/Panorama/PanoramaTools.vue'
import PanoramaOptionsDropdown from 'components/Panorama/PanoramaOptionsDropdown.vue'
import PanoramaShowLateralButton from 'components/Panorama/PanoramaShowLateralButton.vue'
import { QBtn, QHeader, QMenu, QSeparator, QSpace, QToolbar, QTooltip } from 'quasar'

export default {
  name: 'AppHeader',
  props: [
    'brandLogo',
    'brandText'
  ],
  components: {
    AuthHeaderItem,
    PanoramaCampaignsDropdown,
    PanoramaTools,
    PanoramaOptionsDropdown,
    PanoramaShowLateralButton,
    QBtn,
    QHeader,
    QMenu,
    QSeparator,
    QSpace,
    QToolbar,
    QTooltip
  },
  data () {
    return {
      brandLink: '/'
    }
  },
  computed: {
    panoramaHeader () {
      return this.$store.state.basicLayout.panoramaHeader
    },
    isMenu () {
      return this.$q.screen.lt.sm
    }
  },
  methods: {
  }
}
</script>

<style>
</style>
